import { render, staticRenderFns } from "./SubStatusModal.vue?vue&type=template&id=06b1defb&scoped=true"
import script from "./SubStatusModal.vue?vue&type=script&lang=js"
export * from "./SubStatusModal.vue?vue&type=script&lang=js"
import style0 from "./SubStatusModal.vue?vue&type=style&index=0&id=06b1defb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b1defb",
  null
  
)

export default component.exports